import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=5f06ef60&scoped=true"
import script from "./Ecommerce.vue?vue&type=script&lang=ts"
export * from "./Ecommerce.vue?vue&type=script&lang=ts"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=5f06ef60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06ef60",
  null
  
)

export default component.exports